import { useTranslation } from 'next-i18next';
import type { SearchQuizsetRes } from '@/api';
import { LtiSelectQuizButton } from '@/shared/lti/components/LtiSelectQuizButton';
import type { QuizCardMenuItem } from '@/shared/quizList/hooks/useGetQuizListItemButtons';
import { useQuizListItemAction } from '@/shared/quizList/hooks/useQuizListItemAction';
import { Button } from '@/ui_v3';
interface LtiFooterActionsProps {
  quizSet: SearchQuizsetRes;
  menuItems: QuizCardMenuItem[];
}
export const LtiFooterActions = ({
  quizSet,
  menuItems
}: LtiFooterActionsProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    onClickEvent
  } = useQuizListItemAction(quizSet);
  const editAction = menuItems.find(item => item.onClickEventName === 'update');
  const shouldShowSelect = !quizSet.isLocked && menuItems.some(item => item.onClickEventName === 'lti_select');
  return <div className="mt-2xs flex justify-end gap-2xs" data-sentry-component="LtiFooterActions" data-sentry-source-file="LtiFooterActions.tsx">
      {editAction && <Button size="md" variant={editAction.variant ?? 'outlined'} intent={editAction.intent ?? 'neutral'} onClick={e => {
      e.stopPropagation();
      e.preventDefault();
      onClickEvent(editAction.onClickEventName);
    }}>
          <div className="flex items-center gap-2xs">
            <editAction.icon size="xs" className="shrink-0" />
            {t(editAction.label)}
          </div>
        </Button>}
      {shouldShowSelect && <LtiSelectQuizButton quizSetId={quizSet.id} entryMapHashId={quizSet.entryMapHashId} quizTitle={quizSet.title} />}
    </div>;
};